
(function ($) {

  var commentsToShow = 10;
  var currentCommentIndex = 0;

  function showCommentForState(totalComments, selector) {
    if (currentCommentIndex < totalComments) {
      currentCommentIndex = currentCommentIndex + commentsToShow;
      $(selector).slice(0, currentCommentIndex).fadeIn(500);
    }

    if (currentCommentIndex >= totalComments) {
      $('.load-more-block').hide();
    } else {
      $('.load-more-block').show();
    }
  }

  function showTotalComments(totalComments) {
    $('.total-results-comments').text(
      totalComments +
      $('.total-results-comments').attr('data-value'));
  }

  // eslint-disable-next-line max-statements
  function onFilterChanged() {

    var selector = '';
    var totalComments = 0;

    var isInternalSelected =
      $('.filter-controls #filter-internal-comments').is(':checked');
    var isCustomerSelected =
      $('.filter-controls #filter-customer-comments').is(':checked');

    if (!isCustomerSelected && !isInternalSelected) {
      totalComments = 0;
      $('.comment-block').hide();
      $('.load-more-block').hide();
    } else if (isCustomerSelected && isInternalSelected) {
      selector = '.comment-block';
      totalComments = $(selector).length;
      showCommentForState(totalComments, selector);
    } else if (isInternalSelected) {
      selector = '.comment-block.internal';
      totalComments = $(selector).length;
      showCommentForState(totalComments, selector);
    } else if (isCustomerSelected) {
      selector = '.comment-block.customer';
      totalComments = $(selector).length;
      showCommentForState(totalComments, selector);
    }

    showTotalComments(totalComments);
  }

  function ready() {
    if ($('.article-container').length) {

      var totalComments = $('.comment-block').length;

      if (totalComments) {
        $('.existing-comment-title').show();
        $('.results-filter-block').show();

        // default to internal comments
        var selector = '.comment-block.internal';
        var totalInternalComments = $(selector).length;
        showCommentForState(totalInternalComments, selector);
        showTotalComments(totalInternalComments);
      }

      $('.filter-controls :checkbox').click(function () {
        currentCommentIndex = 0;
        $('.comment-block').hide();
        onFilterChanged();
      });

      $('.load-more').on('click', function () {
        onFilterChanged();
      });
    }
  }

  $(document).ready(ready);

}(jQuery));
